import type { User } from "firebase/auth";
import { isFirebaseConfigured } from "@/auth/firebase";
import { callSyncEquippedShadow } from "@/cloud/game-callables";
import type { ShadowDefinition } from "@/shadow/types";

export async function syncEquippedShadowPublic(
  _userId: string,
  equipped: ShadowDefinition | null,
): Promise<void> {
  if (!isFirebaseConfigured()) return;
  try {
    await callSyncEquippedShadow({
      equipped: equipped
        ? {
            name: equipped.name,
            spritesheetDataUrl: equipped.spritesheetDataUrl,
            grid: equipped.grid,
            actions: equipped.actions,
            statAllocation: equipped.statAllocation,
          }
        : null,
    });
  } catch {
    /* best-effort */
  }
}

export async function syncEquippedShadowPublicForUser(
  user: User,
  equipped: ShadowDefinition | null,
): Promise<void> {
  await syncEquippedShadowPublic(user.uid, equipped);
}
